import { createGlobalStyle } from 'styled-components';

const ImageGalleryStyle = createGlobalStyle`
    .image-gallery {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        position: relative
    }

    .image-gallery.fullscreen-modal {
        background: #000;
        bottom: 0;
        height: 100%;
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 5
    }

    .image-gallery.fullscreen-modal .image-gallery-content {
        top: 50%;
        transform: translateY(-50%)
    }

    .image-gallery-content {
        position: relative;
        line-height: 0;
        top: 0
    }

    .image-gallery-content.fullscreen {
        background: #000
    }

    .image-gallery-content .image-gallery-slide .image-gallery-image {
        max-height: calc(100vh - 80px)
    }

    .image-gallery-content.left .image-gallery-slide .image-gallery-image, .image-gallery-content.right .image-gallery-slide .image-gallery-image {
        max-height: 100vh
    }

    .image-gallery-slide-wrapper, .image-gallery-slide.center, .image-gallery-thumbnails-wrapper {
        position: relative
    }

    .image-gallery-slide-wrapper.left, .image-gallery-slide-wrapper.right {
        display: inline-block;
        width: calc(100% - 110px)
    }

    .image-gallery-slide-wrapper.image-gallery-rtl, .image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {
        direction: rtl
    }

    .image-gallery-slides {
        line-height: 0;
        overflow: hidden;
        position: relative;
        white-space: nowrap;
        text-align: center
    }

    .image-gallery-slide {
        left: 0;
        position: absolute;
        top: 0;
        width: 100%
    }

    .image-gallery-slide .image-gallery-image {
        width: 100%;
        object-fit: contain
    }

    .image-gallery-slide .image-gallery-description {
        background: rgba(0, 0, 0, .4);
        bottom: 70px;
        color: #fff;
        left: 0;
        line-height: 1;
        padding: 10px 20px;
        position: absolute;
        white-space: normal
    }

    .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
        touch-action: pan-y
    }

    .image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical {
        touch-action: pan-x
    }

    .image-gallery-thumbnails-wrapper.left, .image-gallery-thumbnails-wrapper.right {
        display: inline-block;
        vertical-align: top;
        width: 100px;
        margin: 0 5px
    }

    .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails, .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails {
        height: 100%;
        width: 100%;
        left: 0;
        padding: 0;
        position: absolute;
        top: 0
    }

    .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails .image-gallery-thumbnail {
        display: block;
        margin-right: 0;
        padding: 0
    }

    .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail {
        margin-left: 0;
        margin-top: 2px
    }

    .image-gallery-thumbnails {
        overflow: hidden;
        padding: 5px 0
    }

    .image-gallery-thumbnails .image-gallery-thumbnails-container {
        cursor: pointer;
        text-align: center;
        white-space: nowrap
    }

    .image-gallery-thumbnail {
        display: inline-block;
        border: 4px solid transparent;
        transition: border .3s ease-out;
        width: 100px;
        background: 0 0;
        padding: 0
    }

    .image-gallery-thumbnail + .image-gallery-thumbnail {
        margin-left: 2px
    }

    .image-gallery-thumbnail .image-gallery-thumbnail-inner {
        display: block;
        position: relative
    }

    .image-gallery-thumbnail .image-gallery-thumbnail-image {
        vertical-align: middle;
        width: 100%;
        line-height: 0
    }

    .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
        outline: 0;
        border: 4px solid #337ab7
    }

    @media (max-width: 768px) {
        .image-gallery-slide-wrapper.left, .image-gallery-slide-wrapper.right {
            width: calc(100% - 87px)
        }

        .image-gallery-slide .image-gallery-description {
            bottom: 0px;
            font-size: .8em;
            padding: 8px 15px
        }

        .image-gallery-thumbnails-wrapper.left, .image-gallery-thumbnails-wrapper.right {
            width: 81px;
            margin: 0 3px
        }

        .image-gallery-thumbnails {
            padding: 3px 0
        }

        .image-gallery-thumbnail {
            border: 3px solid transparent;
            width: 81px
        }

        .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
            border: 3px solid #337ab7
        }
    }

    @media (hover: hover) and (pointer: fine) {
        .image-gallery-thumbnail:hover {
            outline: 0;
            border: 4px solid #337ab7
        }
    }

    @media (hover: hover) and (pointer: fine) and (max-width: 768px) {
        .image-gallery-thumbnail:hover {
            border: 3px solid #337ab7
        }
    }
`;

export default ImageGalleryStyle;
